import { useTranslation } from 'react-i18next';
import IcCheck from '@/assets/icons/Check.svg?react';
import styles from './WhatThisUnlocks.module.scss';

const WhatThisUnlocks = () => {
  const { t } = useTranslation(['onboarding']);

  const bullets = [
    t('onboarding:kycVerified.aside.bullets.qes'),
    t('onboarding:kycVerified.aside.bullets.aes'),
    t('onboarding:kycVerified.aside.bullets.reusable'),
  ];

  return (
    <section className={styles.card}>
      <h2 className={styles.title}>
        {t('onboarding:kycVerified.aside.title')}
      </h2>
      <div className={styles.desc}>
        {t('onboarding:kycVerified.aside.desc')}
      </div>
      <ul className={styles.list}>
        {bullets.map((bullet) => (
          <li key={bullet} className={styles.row}>
            <span className={styles.bullet} aria-hidden="true">
              <IcCheck />
            </span>
            <span>{bullet}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default WhatThisUnlocks;
